export default "/fonts/vendor/@fortawesome/fontawesome-free/webfa-brands-400.woff?dc2cbadd690e1d4b2c9c11c8143d027c";